"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_config_1 = require("react-router-config");
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const withAuthorization_1 = __importDefault(require("../../../common/js/hoc/withAuthorization"));
class SoftwarePage extends react_1.default.Component {
    render() {
        return (0, react_router_config_1.renderRoutes)(this.props.route?.routes);
    }
}
exports.default = (0, auth0_react_1.withAuth0)((0, withAuthorization_1.default)({ scope: AuthorizationScopes_1.default.SOFTWARE_READ })((0, mobx_react_1.observer)(SoftwarePage)));
